
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const KaimoorWildlife=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Kaimoor Wildlife Sanctuary</h1>
           <p className="sub-heading">Uttar Pradesh's largest sanctuary, a haven of biodiversity nestled in the scenic Kaimur Hills</p>
         </div>
         <div className="description">
         Kaimoor Wildlife Sanctuary, spread across 1,342 sq. km in the picturesque Kaimur Hills of Sonbhadra and Mirzapur, is a treasure trove of flora and fauna. The sanctuary is home to Blackbucks, Chinkaras, Sloth Bears, Leopards, and over 70 bird species, with migratory birds flocking here in winter. Visitors can explore ancient cave paintings, the oldest Fossil Park, and mesmerizing waterfalls like Karkat and Telhar. Easily accessible via rail, road, and the Varanasi airport, this sanctuary offers an enriching experience for nature enthusiasts and wildlife lovers.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/2.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/4.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/5.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/6.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/7.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/8.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/9.png')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/10.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/11.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/12.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Kaimoor Wildlife Sanctuary/13.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
         </div>
   
         <BookSection />
       </div>
     );
};